import Resources from '../../../helpers/resources';
import { ENDPOINT_PATH_LIVE_MATHS } from '../../../helpers/constants';
import DateParamHelper from '../../../helpers/date-param-helper';
import errorsActions from '../../app/errors/errors-actions';

export const LIVE_MATHS_STUDENT_RETRIEVED = 'LIVE_MATHS_STUDENT_RETRIEVED';

function getLiveMathsData(studentId, classroomId, selectedDateFilter) {
    return (dispatch) =>
        Resources.studentReport
            .get({
                reportType: ENDPOINT_PATH_LIVE_MATHS,
                ...DateParamHelper.getDateTypePath(selectedDateFilter),
                classroomId,
                userProfileId: studentId
            })
            .withParams(DateParamHelper.getDateQueryParams(selectedDateFilter))
            .send()
            .then((payload) => {
                if (payload.valid) {
                    dispatch({
                        type: LIVE_MATHS_STUDENT_RETRIEVED,
                        payload: mapLiveMathsData(payload.data)
                    });
                } else {
                    dispatch(
                        errorsActions.addError(LIVE_MATHS_STUDENT_RETRIEVED)
                    );
                }
            });
}

function mapLiveMathsData(data) {
    const mappedLiveMathsResults = data.liveMathsResults.map((result) => ({
        id: result.level,
        level: result.level,
        totalCorrect: mapLiveMathsScore(result.totalCorrect),
        topScore: mapLiveMathsScore(result.topScore),
        accuracy: mapLiveMathsScore(result.accuracy, '%'),
        questionsPerMinute: mapLiveMathsScore(result.questionsPerMinute)
    }));

    return {
        ...data,
        liveMathsResults: mappedLiveMathsResults
    };
}

function mapLiveMathsScore(score, suffix) {
    if (score === -1) {
        return '-';
    } else if (suffix) {
        return `${score}${suffix}`;
    }
    return score;
}

export default {
    getLiveMathsData
};



// WEBPACK FOOTER //
// ./containers/live-maths/student/student-actions.js